<template>
  <div class="remove-wrapper" :class="{'content-wrapper':remove == false}" v-if="companyId">
    <div class="row">
      <div class="col-sm-12 col-md-6" >
        <!-- <app-breadcrumb :page-title="$t('my_audit_request')" :directory="$t('datatables')" :icon="'grid'"/> -->
        <app-breadcrumb :page-title="$t('my_profile')" :icon="'user'" v-if="remove === false"/>
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button" v-if="verify_show === true">
        <div class="float-md-right mb-2 mb-sm-2 mb-md-0">
          <app-avatar
            v-if="company && company.package"
            :title="$t('avatars')"
            class="mb-5"
            avatar-class="avatars-w-80"
            :img="company.package.image"
            :shadow="true"
            :border="true"
            :alt-text="$t('not_found')"
          />
        </div>
      </div>
    </div>
    
     <!-- <div style="display:flex; justify-content:flex-end" v-if="typeof(this.statusCheck) != 'undefined' ">
         <h5 v-if="statusCheck == '1'" class="text-success">{{ statusCheck == "1" ? 'Approved (Supplier)' : 'Pending (Supplier)'}}</h5>
         <h5 v-else class="text-warning">{{ statusCheck == "1" ? 'Approved (Supplier)' : 'Pending (Supplier)'}}</h5> -->

    <!-- </div> -->


    <div class="user-profile mb-primary">
      <div class="card position-relative card-with-shadow py-primary border-0">
        <app-overlay-loader v-if="componentLoader" class="h-100" />
        <div v-else class="row align-items-center">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
            <div
              class="
                media
                border-right
                px-5
                pr-xl-5
                pl-xl-0
                align-items-center
                user-header-media
              "
            >
              <form
                class="mb-0"
   
                ref="form"
                data-url="admin/auth/users/profile-picture"
                :class="{ 'loading-opacity': preloader }"
              >
                <div class="profile-pic-wrapper position-relative">
                  <app-overlay-loader v-if="preloader" />
                  <app-input
                    v-else
                    id="user_image"
                    class="mx-xl-auto"
                    :wrapper-class="'mx-xl-auto'"
                    name="user_image"
                    type="custom-file-upload"
                    v-model="profilePicture"
                    :generate-file-url="false"
                    @change="setProfilePicture"
                    :label="$t('change')"
                  />
                </div>
              </form>
              <div class="media-body user-info-header">
                <h6>
                  <!-- {{ user.loggedInUser.full_name }} -->
                  {{ company.company_name }}
                </h6>
                <!-- <p class="text-muted mb-2">{{ user.loggedInUser.email }}</p> -->
                <p class="text-muted mb-2">{{ userInfos.email }}</p>

                <span :class="['badge badge-pill user-status', hasOverdueInvoice ? 'badge-danger' : 'badge-success']">
                  {{ hasOverdueInvoice ? $t("inactive") : $t("active") }}
                </span>
                <div class="social-links pt-3">
                  <a
                    class="mr-3"
                    v-for="socialLink in user.socialLinks"
                    v-if="socialLink.link"
                    :href="socialLink.link"
                    target="_blank"
                  >
                    <app-icon
                      class="mb-1"
                      :name="socialLink.icon"
                      width="16"
                      height="16"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
            <div
              class="
                user-details
                px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0
                mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  <div class="border-right custom">
                    <div class="media mb-4 mb-xl-5">
                      <div class="align-self-center mr-3">
                        <app-icon :name="'phone'" />
                      </div>
                      <div class="media-body">
                        <p class="text-muted mb-0">{{ $t("contact") }}:</p>
                        <p class="mb-0">
                          <!-- {{
                            user.loggedInUser.contact
                              ? user.loggedInUser.contact
                              : $t("not_available")
                          }} -->
                          {{
                            company.company_phone
                              ? company.company_phone
                              : $t("not_available")
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="media mb-4 mb-xl-0">
                      <div class="align-self-center mr-3">
                        <app-icon :name="'map-pin'" />
                      </div>
                      <div class="media-body">
                        <p class="text-muted mb-0">{{ $t("address") }}:</p>
                        <p class="mb-0">
                          <!-- {{
                            user.loggedInUser.address
                              ? user.loggedInUser.address
                              : $t("not_available")
                          }} -->
                          {{company.address ? company.address : $t("not_available")
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  <div class="media mb-4 mb-xl-5">
                    <div class="align-self-center mr-3">
                      <app-icon :name="'calendar'" />
                    </div>
                    <div class="media-body">
                      <p class="text-muted mb-0">{{ $t("created") }}:</p>
                      <!-- <p class="mb-0">{{ user.loggedInUser.created_at }}</p> -->
                      <p class="mb-0">{{ userInfos.created_at | formatDate }}</p>
                    </div>
                  </div>
<!--                  <div class="media mb-0 mb-xl-0">-->
<!--                    <div class="align-self-center mr-3">-->
<!--                      <app-icon :name="'gift'" />-->
<!--                    </div>-->
<!--                    <div class="media-body">-->
<!--                      <p class="text-muted mb-0">{{ $t("date_of_birth") }}:</p>-->
<!--                      <p class="mb-0">-->
<!--                        {{-->
<!--                          user.loggedInUser.profile-->
<!--                            ? user.loggedInUser.profile.date_of_birth-->
<!--                            : $t("not_available")-->
<!--                        }}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-2">
            <!-- <div class="">
                      <app-avatar
                        :title="$t('avatars')"
                        class="mb-5"
                        avatar-class="avatars-w-80"
                        :img="company.package.image"
                        :shadow="true"
                        :border="true"
                        :alt-text="$t('not_found')"
                      />
                    </div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showProfileCompletionWizard"
      class="card card-with-shadow border-0 mb-primary profile-completion-card"
    >
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start flex-wrap">
          <div>
            <h5 class="mb-1">{{ $t('profile_completion_wizard') }}</h5>
            <p class="text-muted mb-0">
              {{ $t('complete_profile_information_for_operations') }}
            </p>
          </div>
          <div class="completion-score text-right">
            <strong>{{ profileCompletionPercent }}%</strong>
            <span class="text-muted d-block">{{ $t('completed') }}</span>
          </div>
        </div>
        <div class="progress mt-3">
          <div
            class="progress-bar"
            role="progressbar"
            :style="{ width: profileCompletionPercent + '%' }"
            :aria-valuenow="profileCompletionPercent"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div class="row mt-3">
          <div
            class="col-md-6 col-xl-4 mb-2"
            v-for="step in profileCompletionSteps"
            :key="step.key"
          >
            <button
              type="button"
              class="completion-step w-100"
              :class="{ 'is-complete': step.complete }"
              @click.prevent="openProfileStep(step.tab)"
            >
              <span class="completion-icon">
                <app-icon :name="step.complete ? 'check' : 'alert-circle'"/>
              </span>
              <span class="text-left">
                <strong>{{ step.label }}</strong>
                <small class="d-block text-muted">{{ step.description }}</small>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-tab :tabs="tabs" :icon="tabIcon" :verifyShow="verify_show" />
  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { UserMixin } from "./Mixins/UserMixin";
import * as actions from "../../../Config/ApiUrl";
import { axiosGet } from "../../../Helpers/AxiosHelper";

export default {
  name: "Profile",
  mixins: [FormMixin, UserMixin],
  props: {
    id: Number,
    remove: Boolean,
    statusCheck: String,
    data:{},
  },
  data() {
    return {
      profilePicture: '',
      verify_show: false,
      userCompanyId: 0,
      userInfos: {},
      hasOverdueInvoice: false,
      // route_name:'',
      logoCompany: {},
      company: {},
      preloader: true,
      tabIcon: "user",
      tabs: [
        {
          name: this.$t("company_info"),
          title: this.$t("company_profile"),
          component: "company-information",
          permission: true,
          props: {'company': this.company},
        },
        {
          name: this.$t("business_detail"),
          title: this.$t("business_detail"),
          component: "company-business-detail",
          permission: true,
          props: {},
        },
        {
          name: this.$t("other_detail"),
          title: this.$t("other_detail"),
          component: "company-other-business-detail",
          permission: true,
          props: {},
        },
        {
          name: this.$t("services"),
          title: this.$t("services"),
          component: "company-services",
          permission: true,
        },
        {
          name: this.$t("membership_info"),
          title: this.$t("membership_info"),
          component: "membership-info",
          permission: true,
        },
        {
          name: this.$t("compliance"),
          title: this.$t("compliance"),
          component: "profile-certificates-list",
          permission: true,
        },
        {
          name: this.$t("active_certificates"),
          title: this.$t("active_certificates"),
          component: "certificate-profile",
          permission: true,
        },
        {
          name: this.$t("training"),
          title: this.$t("training"),
          component: "training-list",
          permission: true,
        },
        {
          name: this.$t("mydocument"),
          title: this.$t("mydocument"),
          component: "mydocument-index",
          permission: true,
        },
        {
          name: this.$t("user_info"),
          title: this.$t("user_info"),
          component: "personal-information",
          permission: true,
          props: {},
        },
        {
          name: this.$t("password_change"),
          title: this.$t("password_change"),
          component: "password-change",
          permission: true,
        },
        {
          name: this.$t("social_links"),
          title: this.$t("social_links"),
          component: "social-links",
          permission: true,
        },
        {
          name: "Screening Report Template",
          title: "Screening Report Template",
          component: "report-template-settings",
          permission: true,
        },
        // {
        //   name: this.$t("questionnaire"),
        //   title: this.$t("questionnaire"),
        //   component: "questionnaire",
        //   permission: "",
        // },
        {
          name: this.$t("membership_questionnaire_tasks"),
          title: this.$t("membership_questionnaire_tasks"),
          component: "tasks",
          permission: "",
        },
      ],
    };
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    checkOverdueInvoice() {
      axiosGet(actions.LAST_INVOICE)
        .then((response) => {
          if (response.data.result === 'pending') {
            this.hasOverdueInvoice = true;
          } else {
            this.hasOverdueInvoice = false;
          }
        })
        .catch(() => {});
    },
    setProfilePicture($event) {
      if(this.companyId == this.company.id) {
        const fileValue = $event.target.files[0];
        let formData = new FormData();
        formData.append("profile_picture", fileValue);
        this.save(formData);
      }
      else {
        this.$toastr.i('You cannot change any User Profile Picture');
      }
      
    },
    openProfileStep(tabName) {
      const url = new URL(window.location.href);
      url.searchParams.set('tab', tabName);
      window.location.href = url.pathname + url.search;
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      window.location = actions.MY_PROFILE;
    },
    setTabs(userCompanyId, userData) {
      var url = window.location.pathname;
      var profileType = url.substring(url.lastIndexOf("/") + 1);

      if(profileType != "my-profile") {
        this.tabs.forEach((element) => {
          if (element.name == this.$t("mydocument")) {
            element.permission = false;
          }
          if (element.name == this.$t("services")) {
            element.permission = false;
          }
          if (element.name == this.$t("user_info")) {
            element.props = {userData: userData};
          }
          if (element.name == this.$t("password_change")) {
            element.permission = false;
          }
          if (element.name == this.$t("social_links")) {
            element.permission = false;
          }
          if (element.name == "Screening Report Template") {
            element.permission = false;
          }
          if (element.name == this.$t("company_info")) {
            element.props = {companyId: userCompanyId};
          }
          if (element.name == this.$t("certifications")) {
            element.props = {companyId: userCompanyId};
          }
        });
      }
      else {
        this.tabs.forEach((element) => {
          if (element.name == this.$t("company_info")) {
            element.props = {companyId: userCompanyId};
          }
          if (element.name == this.$t("business_detail")) {
            element.props = {companyId: userCompanyId};
          }
          if (element.name == this.$t("other_detail")) {
            element.props = {companyId: userCompanyId};
          }
          if (element.name == this.$t("user_info")) {
            element.props = {userData: this.$store.state.user.loggedInUser};
          }
          if (this.isCompanyAdmin == 0) {
            if (element.name == this.$t("company_info") || element.name == this.$t("user_info") || element.name == this.$t("password_change") || element.name == this.$t("mydocument")) {
                element.permission = true;
            }
            else {
              element.permission = false;
            }
          }
        });
      }
    },
    getCompanyInfo() {

      // var url = window.location.pathname;
      // var id = url.substring(url.lastIndexOf("/") + 1);

      var apiUrl = "";

      // if (id == "my-profile") {
      //   // var userId = this.user.loggedInUser.id;
        // // var userId = this.$attrs['id'];
      //   apiUrl = actions.COMPANY_PROFILE_VIEW + userId;
      // } else {
        apiUrl = actions.COMPANY_PROFILE_VIEW + this.id;
      // }
      axiosGet(apiUrl)
        .then((res) => {
          this.company = res.data.company;
          this.userInfos = res.data;

          if(res.data.profile_picture && res.data.profile_picture.path) {
            this.profilePicture = res.data.profile_picture.path;
          }
          if (res.data.company && res.data.company.is_verify) {
            this.verify_show = true;
          }
          this.$store.state.userCompanyProfile.dataProfile = res.data;
          // console.log('hello id',res.data.company.id);
          if (res.data.company) {
            this.setTabs(res.data.company.id, this.userInfos);
          } else {
            this.setTabs(null, this.userInfos);
          }
          // this.$toastr.s(res.data.type);
        })
        .catch((error) => {
          
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
          $("#demo-add-edit-Modal").modal("hide");
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
  },
  mounted() {
        this.getCompanyInfo();
        this.checkOverdueInvoice();
 },
  computed: {
    companyId() {
      return this.$store.state.user.loggedInUser.company_id;
    },
    isCompanyAdmin() {
      return this.$store.state.user.loggedInUser.is_company_admin;
    },
    showProfileCompletionWizard() {
      return this.remove !== true && this.isCompanyAdmin === 1 && this.profileCompletionPercent < 100;
    },
    profileCompletionSteps() {
      const company = this.company || {};
      const otherDetail = company.other_detail || {};
      const user = this.userInfos || {};
      const websiteLink = (this.user.socialLinks || []).find((link) => {
        return (link.name || '').toString().toLowerCase() === 'website';
      });

      return [
        {
          key: 'company',
          label: this.$t('company_info'),
          description: this.$t('name_contact_address'),
          tab: this.$t('company_info'),
          complete: Boolean(company.company_name && company.company_email && company.company_phone && company.address),
        },
        {
          key: 'business',
          label: this.$t('business_detail'),
          description: this.$t('registration_and_business_details'),
          tab: this.$t('business_detail'),
          complete: Boolean(company.comapny_number && company.address_line_1 && company.city && company.postal_code),
        },
        {
          key: 'other',
          label: this.$t('other_detail'),
          description: this.$t('operational_profile_details'),
          tab: this.$t('other_detail'),
          complete: Boolean(otherDetail.sme_status && otherDetail.environment_policy && otherDetail.ssip_accredited),
        },
        {
          key: 'user',
          label: this.$t('user_info'),
          description: this.$t('admin_contact_details'),
          tab: this.$t('user_info'),
          complete: Boolean(user.first_name && user.last_name && user.email && user.phone),
        },
        {
          key: 'social',
          label: this.$t('social_links'),
          description: this.$t('website_required_for_certificates'),
          tab: this.$t('social_links'),
          complete: Boolean(websiteLink && websiteLink.link),
        },
      ];
    },
    profileCompletionPercent() {
      const steps = this.profileCompletionSteps;
      if (!steps.length) {
        return 0;
      }

      const completed = steps.filter((step) => step.complete).length;
      return Math.round((completed / steps.length) * 100);
    }
    // activeField() {
    //   var url = window.location.pathname;
    //   var id = url.substring(url.lastIndexOf("/") + 1);
    //   if (id == "my-profile") {
    //     setTimeout(() => {
    //       this.getCompanyInfo();
    //     }, 3000);
    //   } else {
    //     this.getCompanyInfo();
    //   }
    //   // return this.$store.state.formBuilder.activeField;
    // },
    // userProfile() {
    //   return this.$store.state.user.loggedInUser;
    // },
  },
};
</script>
<style scoped>
.user-profile .card {
  min-height: 190px;
}
.profile-completion-card .progress {
  height: 8px;
  border-radius: 999px;
}
.profile-completion-card .progress-bar {
  background-color: #4466f2;
}
.completion-score strong {
  font-size: 28px;
  line-height: 1;
}
.completion-step {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 72px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  color: #3f4254;
}
.completion-step.is-complete {
  border-color: #d1fae5;
  background: #f0fdf4;
}
.completion-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f3f4f6;
}
.completion-step.is-complete .completion-icon {
  background: #22c55e;
  color: #fff;
}
</style>
